/**
 * Visual tours that guide visitors around the minimal dashboard.
 */

export interface TourStep {
  path: string
  target: string
  text: string
  clickToContinue?: boolean
}

export interface Tour {
  id: string
  title: string
  summary: string
  keywords: string[]
  needsData: boolean
  steps: TourStep[]
}

export const TOURS: Tour[] = [
  {
    id: 'appearance',
    title: 'Change the theme, contrast or colours',
    summary: 'Light or dark, high contrast or soft, and chart colours that suit your eyes.',
    keywords: [
      'theme',
      'dark',
      'light',
      'colour',
      'color',
      'palette',
      'colour blind',
      'contrast',
      'low vision',
      'glare',
      'accessibility',
      'accent',
      'primary colour',
    ],
    needsData: false,
    steps: [
      {
        path: '/settings',
        target: 'theme-setting',
        text: 'Light, dark, or whatever your system uses.',
      },
      {
        path: '/settings',
        target: 'accent-setting',
        text: 'The colour of buttons, links and selection.',
      },
      {
        path: '/settings',
        target: 'contrast-setting',
        text: 'High contrast for low vision, or soft colours for less glare.',
      },
      {
        path: '/settings',
        target: 'palette-setting',
        text: 'Colours for pass, fail and the rest, including schemes for colour blindness.',
      },
    ],
  },
  {
    id: 'load-samples',
    title: 'Load sample assessments',
    summary: 'Explore real research software quality assessments.',
    keywords: ['sample', 'load', 'example', 'demo', 'assessments', 'start'],
    needsData: false,
    steps: [
      {
        path: '/welcome',
        target: 'load-all-samples',
        text: 'Load all sample assessments into this browser session.',
      },
    ],
  },
]

/** Tours whose title, summary or keywords contain every word of the query. */
export function searchTours(query: string, tours: Tour[] = TOURS): Tour[] {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean)
  return tours.filter((tour) => {
    const text = [tour.title, tour.summary, ...tour.keywords].join(' ').toLowerCase()
    return words.every((word) => text.includes(word))
  })
}
